const PARAMS = { serialNumber: 'serialNumber', martyVersion: 'martyVersion', deviceId: 'deviceId', userRole: 'userRole', appVersion: 'appVersion' };
export type UserRoleType = "teacher" | "student" | null;

export const getUrlParams = () => {
    const currentUrl = window.location.href;
    const urlParams = new URLSearchParams(new URL(currentUrl).search);
    let serialNumber = urlParams.get(PARAMS.serialNumber);
    let martyVersion = urlParams.get(PARAMS.martyVersion);
    let appVersion = urlParams.get(PARAMS.appVersion);
    let deviceId = urlParams.get(PARAMS.deviceId);
    let userRole = urlParams.get(PARAMS.userRole);
    serialNumber = serialNumber === "null" ? null : serialNumber;
    martyVersion = martyVersion === "0.0.0" ? null : martyVersion;
    deviceId = deviceId === "null" ? null : deviceId;
    userRole = userRole === "null" ? null : userRole as UserRoleType;
    appVersion = appVersion === "null" ? null : appVersion;

    return { serialNumber, martyVersion, userRole, deviceId, appVersion };
}